import {
  TOGGLE_CG_SLIP
} from 'Store/constants';

const initialState = {
  isOpen: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_CG_SLIP:
      return { ...state, isOpen: !state.isOpen };
    
    default:
      return state;
  }
};
